import { isBelowiOS26 } from '@/lib/utils/iosCompat'
import { useAppSelector } from '@/redux/store'
import { useRouter, type NativeStackHeaderItem } from 'expo-router'
import { Platform } from 'react-native'

// NativeTabs.BottomAccessory needs iOS 26, so below that the tab root screens
// carry the Jiri entry as a header button instead.
export default function useJiriHeaderItems(): NativeStackHeaderItem[] {
  const router = useRouter()
  const jiriMobile = useAppSelector(state => state.session.jiriMobile)

  if (Platform.OS !== 'ios' || !isBelowiOS26 || !jiriMobile) return []

  return [
    {
      type: 'button',
      label: '问问 Jiri',
      icon: { type: 'sfSymbol', name: 'sparkles' },
      onPress: () => router.push('/jiri'),
    },
  ]
}
